import { dataFolderStarSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconFolderStarSolid = /*#__PURE__*/createIcon(dataFolderStarSolid)
export default IconFolderStarSolid
